// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-number-field .yxt-input-number{width:100%!important}.lc-am-number-field .yxt-input-number ::v-deep.yxt-input-number__decrease,.lc-am-number-field .yxt-input-number ::v-deep.yxt-input-number__increase{display:unset!important}.lc-am-number-field .unit{position:absolute;right:40px;top:50%;transform:translateY(-50%)}", ""]);
// Exports
module.exports = exports;
